import { render, staticRenderFns } from "./SubjectContractsComponent.vue?vue&type=template&id=6ddb35ce"
import script from "./SubjectContractsComponent.vue?vue&type=script&lang=js"
export * from "./SubjectContractsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports